<template>
  <div class="full-screen-container" :style="telaCheiaBg">
    <div class="media-column" style="position: relative;">
      <div class="media-background" :style="midiaBgStyle" />
      <div style="z-index: 2;max-width: 550px; display: flex; align-content: center;margin-bottom: 32px;">
        <span class="title-text">{{ headerText }}</span>
      </div>
      <div class="media-wrapper">
        <img v-if="midiaType === 'image'" :src="midiaUrl" class="image" style="position: relative;" />
        <video v-else :src="midiaUrl" class="video" autoplay style="position: relative;" />
      </div>
    </div>
  </div>
</template>

<script>
const midiaBg = require("../../../assets/tarjas/panela-sportv/midia-vertical-container.png");
const midiaTelaCheiaBg = require("../../../assets/tarjas/panela-sportv/midia-tela-cheia-bg.png");

export default {
  props: {
    headerText: String,
    midiaType: String,
    midiaUrl: String,
    midiaSize: Object,
  },
  computed: {
    telaCheiaBg() {
      const size = `width: 100vw; min-height: 100vh`;
      const backgroundStyle = `background-image: url(${midiaTelaCheiaBg}); `;
      return `${backgroundStyle}; ${size}`;
    },
    midiaBgStyle() {
      const backgroundStyle = `background-image: url(${midiaBg}); background-repeat: round; background-size: contain;`;
      return `${backgroundStyle};`;
    }
  },
};
</script>

<style scoped lang="scss">
.full-screen-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.media-column {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 2;
}

.media-wrapper{
  display: flex;
  align-items: center;
  max-width: 474px;
  max-height: 832px;
}

.image,
.video {
  width: 100%;
  z-index: 1;
  border: 6px solid #bff65c;
  border-radius: 6px;
}

.title-text {
  font-size: 3.8em;
  line-height: 4rem;
  color: white;
  z-index: 2;
  text-align: center;
  font-family: "Galeana-Condensed-Black", sans-serif;
}

.media-background{
  position: absolute; 
  z-index: 0;
  width: 700px;
  height: 100vh;
}
</style>
